import React from "react";
import { CircularProgress, IconButton, Typography } from "@mui/material";

const EditButton = ({ onClick, label, style, isLoading }) => {
  return (
    <IconButton
      onClick={onClick}
      sx={{
        borderRadius: "7px",
        backgroundColor: "rgba(0,0,0,0.1)",
        px: 2,
        py: 0.7,
        display: "flex",
        alignItems: "center",
        gap: "5px",
        position: "relative",
        "&:hover": { backgroundColor: "rgba(0,0,0,0.16)" },
        "&.Mui-disabled": { backgroundColor: "rgba(0,0,0,0.1)" },
        ...style,
      }}
      disabled={isLoading ? true : false}
    >
      <Typography fontSize={15} fontWeight={600} color="rgba(0,0,0,0.8)">
        {label ? label : "Edit"}
      </Typography>
      {isLoading ? (
        <CircularProgress
          size={24}
          sx={{
            color: "primary.main",
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      ) : null}
    </IconButton>
  );
};

export default EditButton;
